var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgEdit = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M11.12 2.761 9.176 4.706l2.112 2.119 1.949-1.951-2.119-2.113Zm-.774 5.007L8.234 5.65l-5.567 5.573v2.112h2.12l5.56-5.566Zm-5.462 5.566h-.002.002Zm-2.217-2.21v.002-.002Zm8.026-9.705a1.105 1.105 0 0 1 1.212.243l2.432 2.425.002.002a1.103 1.103 0 0 1 0 1.568l-8.68 8.689-.001.002a1.1 1.1 0 0 1-.777.319H4.88L4.882 14v.667H2.438a1.105 1.105 0 0 1-1.105-1.103v-2.437.001L2 11.126h-.667m9.36-9.707a1.105 1.105 0 0 0-.358.241l.358-.241Z",
    clipRule: "evenodd"
  })));
});
SvgEdit.displayName = "SvgEdit";
export default SvgEdit;